import axiosClient from '@/config/api/axios'
import { INTEGRATION_TOOLKITS } from '@/config/api/endpoints'
import { toolkitListSchema } from '@/schemas/integrations/toolkit'

/**
 * The connectable app catalogue.
 *
 * Unlike the connection calls this throws on failure: an empty catalogue and a
 * broken one look identical to a user browsing apps, so the query must be able
 * to show an error state rather than an empty grid.
 *
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function fetchToolkits(options = {}) {
  const { data } = await axiosClient.get(INTEGRATION_TOOLKITS, { signal: options.signal })
  return toolkitListSchema.parse(data).items
}
